import { useMutation, useQueryClient } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "../../Environment";

export interface LinkAttachmentUpdatePayload {
  attachmentId: string;
  name: string;
  url: string;
}

export const useTaskLinkAttachmentUpdateMutation = (
  taskId: string | null | undefined,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: LinkAttachmentUpdatePayload) => {
      return ApiRequest.put(
        `${requestURLs.task}attachment/link/${data.attachmentId}`,
        { name: data.name, url: data.url }
      );
    },
    onSuccess: () => {
      if (taskId) {
        queryClient.invalidateQueries({ queryKey: ["task-attachment", taskId] });
      }
    },
  });
};
